//vehicle selector directive link function
var VehicleSelectorDirectiveLink = function ($scope, $element, $attrs) {
    //continueWithExistingVehicle
    //
    //@param {object} the vehicle to proceed
    //
    //@description
    //Customer has clicked on existing vehicle. In this case we have to call
    //appropriate method of parent scope and pass to one given vehicle. By 
    //busenes logic after vehicle selection the verification panel should be
    //opened
    $scope.continueWithExistingVehicle = function (vehicle, customer) {
        $scope.openVerificationPanel.call(null, vehicle, customer, $scope.index);
    };
};

//vehicle selector directive link function injections
VehicleSelectorDirectiveLink.$inject = ['$scope', '$element', '$attrs']

//vehicle selector directive implementation
module.exports = function () {
    return {
        scope: {
            index: '=',
            customer: '=',
            items: '=',
            selectedVehicle: '<',
            openVerificationPanel: '='
        },
        replace: true,
        restrict: 'E',
        link: VehicleSelectorDirectiveLink,
        templateUrl: 'template/directives/vehicle-selector'
    }
}